import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: 'AIzaSyB25mzrXQijjfeuHbabbQy_JBaNT43fxZg',
//   authDomain: 'winfacil-250ad.firebaseapp.com',
//   projectId: 'winfacil-250ad',
//   storageBucket: 'winfacil-250ad.appspot.com',
//   messagingSenderId: '728222007349',
//   appId: '1:728222007349:web:bd0d469622845ffffff17c',
//   measurementId: 'G-623HEKN4KH',
// };

/**
 * Firebase configuration object using environment variables
 * Contains all necessary Firebase project settings for authentication, database, storage, etc.
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

/**
 * Initialize Firebase application with the provided configuration
 * This creates the main Firebase app instance used throughout the application
 */
export const app = initializeApp(firebaseConfig);

/**
 * Initialize Firebase Cloud Functions
 * Provides access to server-side functions for complex operations
 */
const functions = getFunctions(app);

/**
 * Connect to Firebase Functions emulator in development environment
 * Allows testing of cloud functions locally during development.
 * Set REACT_APP_USE_FUNCTIONS_EMULATOR=false to hit remote functions while running locally.
 */
const shouldUseFunctionsEmulator =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_USE_FUNCTIONS_EMULATOR !== 'false';

if (shouldUseFunctionsEmulator) {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

/**
 * Initialize Firebase Analytics for tracking user interactions and app usage
 */
const analytics = getAnalytics(app);

/**
 * Initialize Firebase Storage for file uploads and downloads
 */
const storage = getStorage(app);

/**
 * Initialize Firestore database for NoSQL document storage
 */
const db = getFirestore(app);

/**
 * Initialize Firebase Authentication for user management
 */
const auth = getAuth(app);

/**
 * Export all initialized Firebase services for use throughout the application
 */
export { auth, db, storage, functions, analytics };
